(function () {
  function anchoDiapositiva(root, slide) {
    const marco = root.querySelector('[data-hero-dual-track-wrap]');
    const referencia = slide || root.querySelector('[data-hero-dual-slide]');
    if (referencia) return referencia.getBoundingClientRect().width;
    return marco?.clientWidth || root.clientWidth || window.innerWidth;
  }

  function initHeroDual(root) {
    if (!root || root.dataset.heroDualReady === 'true') return;

    const pista = root.querySelector('[data-hero-dual-pista]');
    const slides = Array.from(root.querySelectorAll('[data-hero-dual-slide]'));
    const puntos = Array.from(root.querySelectorAll('[data-hero-dual-punto]'));
    const btnPrev = root.querySelector('[data-hero-dual-prev]');
    const btnNext = root.querySelector('[data-hero-dual-next]');

    if (!pista || slides.length < 2) return;

    root.dataset.heroDualReady = 'true';

    let indice = 0;
    let timer = null;
    const intervalo = Math.max(3, Number(root.dataset.intervalo || 6)) * 1000;

    function mostrar(i) {
      indice = (i + slides.length) % slides.length;
      const desplazamiento = indice * anchoDiapositiva(root, slides[0]);
      pista.style.transform = 'translate3d(-' + desplazamiento + 'px, 0, 0)';

      slides.forEach((slide, n) => {
        slide.setAttribute('aria-hidden', n === indice ? 'false' : 'true');
      });
      puntos.forEach((punto, n) => {
        const activo = n === indice;
        punto.classList.toggle('is-active', activo);
        punto.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
    }

    function siguiente() {
      mostrar(indice + 1);
    }

    function anterior() {
      mostrar(indice - 1);
    }

    function reiniciarAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(siguiente, intervalo);
    }

    function onPrev(event) {
      event.preventDefault();
      event.stopPropagation();
      anterior();
      reiniciarAutoplay();
    }

    function onNext(event) {
      event.preventDefault();
      event.stopPropagation();
      siguiente();
      reiniciarAutoplay();
    }

    btnPrev?.addEventListener('click', onPrev, true);
    btnNext?.addEventListener('click', onNext, true);

    puntos.forEach((punto) => {
      punto.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          mostrar(Number(punto.dataset.indice || 0));
          reiniciarAutoplay();
        },
        true
      );
    });

    root.addEventListener('mouseenter', () => {
      if (timer) window.clearInterval(timer);
    });
    root.addEventListener('mouseleave', reiniciarAutoplay);

    const recalcular = () => mostrar(indice);
    window.addEventListener('resize', recalcular);
    if (typeof ResizeObserver !== 'undefined') {
      const marco = root.querySelector('[data-hero-dual-track-wrap]');
      if (marco) {
        const observador = new ResizeObserver(recalcular);
        observador.observe(marco);
      }
    }

    mostrar(0);
    reiniciarAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-dual-carrusel]').forEach(initHeroDual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-hero-dual-carrusel]');
    if (root) {
      delete root.dataset.heroDualReady;
      initHeroDual(root);
    }
  });
})();
